/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 16,
        height: 18,
        viewBox: "0 0 16 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M3.84 3.4c-1.06 0-1.92.86-1.92 1.92V15c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V5.4a2 2 0 0 0-2-2h-.1",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M6.32 2.2v1a1 1 0 0 0 1-1zm3.2 0h-1a1 1 0 0 0 1 1zm-2.2 0c0-.11.1-.2.2-.2V0a2.2 2.2 0 0 0-2.2 2.2zm-1.6 1h.6v-2h-.6zm-.4.4c0-.22.18-.4.4-.4v-2a2.4 2.4 0 0 0-2.4 2.4zm.4.4a.4.4 0 0 1-.4-.4h-2A2.4 2.4 0 0 0 5.72 6zm4.4 0h-4.4v2h4.4zm.4-.4a.4.4 0 0 1-.4.4v2a2.4 2.4 0 0 0 2.4-2.4zm-.4-.4c.22 0 .4.18.4.4h2a2.4 2.4 0 0 0-2.4-2.4zm-.6 0h.6v-2h-.6zM8.32 2q.18.02.2.2h2A2.2 2.2 0 0 0 8.32 0zm-.8 0h.8V0h-.8z",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
